module.exports = __webpack_public_path__ + "img/bg_heart.75211eaf.webp";